export enum ProductQuality {
  original = 'original',
  high = 'high',
  middle = 'middle',
  low = 'low',
}
